import { IModelEntity } from '@pit/core';

export interface IDtoContact extends IModelEntity {

    name?: string;
    phone?: string;

}
